import React from "react";
import useCartStore from "../store/shoppingCardStore";
import styles from "../styles/Navbar.module.css";
import fab from "../images/fab-icon2.png";
import { Link } from "react-router-dom";
import {
  FiShoppingCart,
  FiHome,
  FiBook,
  FiBox,
  FiMail,
  FiPhone,
} from "react-icons/fi";

const Navbar = () => {
  const { itemscount } = useCartStore();
  const total = Object.values(itemscount).reduce(
    (prev, current) => prev + current,
    0
  );

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <img className={styles.logo} alt="fab-icon" src={fab} />
        <span className={styles.brandName}>
          باتری{" "}
          <span
            style={{
              color: "#30c0e4",
            }}
          >
            ۱۰۰
          </span>
        </span>
      </div>

      <nav className={styles.nav}>
        <ul className={styles.list}>
          <li>
            <Link to="/" className={styles.link}>
              <FiHome className={styles.icon} />
              <span>خانه</span>
            </Link>
          </li>
          <li>
            <Link to="/محصولات/" className={styles.link}>
              <FiBox className={styles.icon} />
              <span>محصولات</span>
            </Link>
          </li>
          <li>
            <Link to="/مقالات/" className={styles.link}>
              <FiBook className={styles.icon} />
              <span>مقالات</span>
            </Link>
          </li>
          <li>
            <Link to="/تماس باما/" className={styles.link}>
              <FiPhone className={styles.icon} />
              <span>تماس باما</span>
            </Link>
          </li>
          <li>
            <Link to="/درباره ما/" className={styles.link}>
              <FiMail className={styles.icon} />
              <span>درباره ما</span>
            </Link>
          </li>
          <li className={styles.cartItem}>
            <Link to="/سبد خرید/" className={styles.cartLink}>
              <div className={styles.cartIconContainer}>
                <FiShoppingCart className={styles.cartIcon} />
                {total > 0 && <span className={styles.cartBadge}>{total}</span>}
              </div>
              <span className={styles.carttext}>سبد خرید</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
